import * as React from 'react';
import PropTypes from 'prop-types';
import InputContainer from './input-container';

export default class TextFieldContainer extends React.Component {
	render() {
		return <InputContainer {...this.props} type="text" />;
	}
}

TextFieldContainer.propTypes = {
	disabled    : PropTypes.bool,
	id          : PropTypes.string,
	label       : PropTypes.string,
	loading     : PropTypes.bool,
	multiline   : PropTypes.bool,
	name        : PropTypes.string.isRequired,
	onChange    : PropTypes.func,
	placeholder : PropTypes.string,
	readOnly    : PropTypes.bool,
	required    : PropTypes.bool,
	value       : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	])
}


// WEBPACK FOOTER //
// ./src/component/form/input/textfield-container.js